export interface DecodedOnboardingToken {
    encodedToken: string;
    organizationId: string;
    applicationId: string;
    apiKey: string;
}

const normalizeBase64 = (value: string): string => {
    let normalized = decodeURIComponent(value)
        .replace(/ /g, "+")
        .replace(/-/g, "+")
        .replace(/_/g, "/");

    const remainder = normalized.length % 4;
    if (remainder > 0) {
        normalized = `${normalized}${"=".repeat(4 - remainder)}`;
    }

    return normalized;
};

export const decodeOnboardingToken = (encodedToken: string): DecodedOnboardingToken => {
    if (!encodedToken?.length) {
        throw new Error("Missing onboarding token in the URL.");
    }

    let decoded = "";
    try {
        decoded = window.atob(normalizeBase64(encodedToken));
    } catch (_) {
        throw new Error("The onboarding token could not be decoded.");
    }

    const [organizationId, applicationId, apiKey] = decoded.split("|||");

    if (!organizationId || !applicationId || !apiKey) {
        throw new Error("The onboarding token is missing required application details.");
    }

    return {
        encodedToken,
        organizationId,
        applicationId,
        apiKey
    };
};
